import React from 'react';
import Loader from './Loader';

const LoadingWrapper = ({ isLoading, children, args = {size: '60%', firstColor: 'white', secondColor: '#eeeeee88'}}) => {
    // console.log(args);

    return (
        <span className="">
            {/* Les enfants toujours présents mais invisibles si isLoading est vrai */}
            <span className={`${isLoading ? 'is-loading-wrapper' : ''} flex`}>
                {children}
            </span>
            {/* Loader centré et visible seulement quand isLoading est vrai */}
            {isLoading && (
                <span className="absolute top-0 bottom-0 -translate-x-1/2 left-1/2 flex items-center justify-center">
                    <Loader className={'fill-white white-half'} firstColor={args.firstColor} secondColor={args.secondColor} size={args.size}  />
                </span>
            )}
        </span>
    );
};

export default LoadingWrapper;
